module.exports = __webpack_public_path__ + "img/sk.26bd7983.svg";